import  axiosInstance  from "../utils/api";
 
import endpoints from "../constants/endpoints";




export const ContactUsApi = {

    createContactUsMessage: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.createContactUsMessage}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data; 
        } catch (error) {
            throw new Error('Failed to register user: ' + error.message);
        }
    },
    getListContactUsMessages: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfContactUsMessages}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to register user: ' + error.message);
        }
    },
    searchContactUsMessages: async (searchTerm) => {
        try {
            const response = await axiosInstance.get(`${endpoints.searchContactUsMessages(searchTerm)}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to register user: ' + error.message);
        }
    },
    deleteContactUsMessage: async (messageId) => {
        try {
            const response = await axiosInstance.delete(`${endpoints.deleteContactUsMessage(messageId)}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to register user: ' + error.message);
        }
    },
    getSingleContactUsMessage: async (messageId) => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchSingleContactUsMessage(messageId)}`);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to register user: ' + error.message);
        }
    },
    updateContactUsMessageStatus: async (formData) => {
        try {
            const response = await axiosInstance.put(`${endpoints.updateContactUsMessage}`, formData);
            return response.data; 
        } catch (error) {
            throw new Error('Failed to register user: ' + error.message);
        }
    },

};